// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"025043c7","213":"52664633","239":"5afe8115","452":"8103c099","455":"713d0c73","970":"6b80cce9"}[chunkId] + ".chunk.js";
};